import {
    useState,
    useEffect
} from 'react'
import { useDialogs } from '@shared/hooks/dialogs'
import { useRestForm } from '@shared/hooks/rest/form'
import { useInfiniteList } from '@shared/components/InfiniteList'

import * as yup from 'yup'
import 'yup-phone'
import axios from '@shared/utils/axios'

const schema = props =>
    yup.object({
        username: yup
            .string()
            .required('اكتب هذه الخانة')
            .max(150, 'النص طويل، الحد ١٥٠ حرف'),

        first_name: yup
            .string()
            .required('اكتب هذه الخانة')
            .max(150, 'النص طويل، الحد ١٥٠ حرف'),

        last_name: yup
            .string()
            .required('اكتب هذه الخانة')
            .max(150, 'النص طويل، الحد ١٥٠ حرف'),

        email: yup
            .string()
            .email('البريد الإلكتروني غير صالح')
            .max(254, 'النص طويل، الحد ٢٥٤ حرف'),

        phone_number: yup
            .string()
            .max(13, 'الرقم طويل، الحد هو ١٢ خانة')
            .matches(/^\+\d{1,3}\d{9}$/, {
                message: 'الرقم خاطئ',
                excludeEmptyString: true
            }),

        signature: yup
            .mixed()
            .nullable(),

        user_permissions: yup
            .array(yup.string()),

        is_active: yup.boolean(),

        password: yup.string().when([], {
            is: () => !('instance' in props),
            then: schema => schema.required('اكتب كلمة المرور'),
            otherwise: schema => schema.notRequired()
        })
    })

const buildFormData = (user) => {
    const formData = new FormData()

    Object.entries(user).forEach(([key, value]) => {
        if (key === 'signature' && value) {
            if (value instanceof File) {
                formData.append('signature', value)
            } else if (value === '') {
                formData.append('signature', '')
            }
        } else if (Array.isArray(value)) {
            value.forEach(v => {
                formData.append(key, typeof v === 'object' ? v.id : v)
            })
        } else if (value !== null && value !== undefined) {
            formData.append(key, value)
        }
    })

    return formData
}

export const useForm = (props) => {
    const { close } = useDialogs()
    const {
        form,
        mutate,
        isPending
    } = useRestForm({
        schema: schema(props),
        defaultValues: props?.instance || {},
        invalidate: [['users']],

        process: async user => 'instance' in props
            ? await axios.patch(`settings/users/${user.id}/`, buildFormData(user))
            : await axios.post('settings/users/', buildFormData(user)),
        onFinish: sup => {
            sup()
            close('user')
        }
    })

    // permissions tab
    const [permissions, setPermissions] = useState(props?.instance?.user_permissions || [])
    const [tab, setTab] = useState('data')

    useEffect(() => {
        form.setValue('user_permissions', permissions)
    }, [permissions])

    // estimations tab
    const manager = useInfiniteList({
        key: ['estimations', props?.instance?.id || ''],
        endpoint: 'estimations/',
        params: { user: props?.instance?.id || '' },
        enabled: 'instance' in props
    })

    return {
        form,
        mutate,
        isPending,
        close,

        tab,
        setTab,

        permissions,
        setPermissions,

        manager
    }
}